import { useEffect, useState } from 'react';
import image from '../../../../../page/screens/registerPage/onboarding-survey-step-two-highlight.png';
import authorImage from '../../../../../page/screens/registerPage/tint-portrait-tim-sae-koo.jpg';
import api from '../../../../api';
import { Form } from '../../../components/Form';
import { FormErrorMessage } from '../../../components/Form/FormErrorMessage';
import { FormSelectSimple } from '../../../components/Form/FormInputs';
import { FormItem } from '../../../components/Form/FormItem';
import RegisterFlowTemplate from '../../../components/RegisterFlowTemplate';
import SaveButton from '../../../components/SaveButton';
import { goToOnboardingSurveyOriginStep } from '../../../services/GoTo';
import { VALIDATORS } from '../../../services/Validation';
import styles from '../styles.m.less';

export type FormData = {
    role: string;
    companySize: number;
};

const BUTTON_LABELS = {
    DISABLED: 'Continue',
    ENABLED: 'Continue',
};

const ROLES = ['HR Admin', 'Executive', 'Manager', 'Founder'];

export default function OnboardingSurveyDemographicStep() {
    const [isCompanySizeFilled, setIsCompanySizeFilled] = useState(false);

    useEffect(() => {
        api.onboardingSettings.getCompanySizeFilled().then(setIsCompanySizeFilled);
    }, []);

    const handleSubmit = async (formValues: any) => {
        return api.onboardingSettings
            .createOnboardingSettings(formValues)
            .then(goToOnboardingSurveyOriginStep)
            .catch(goToOnboardingSurveyOriginStep);
    };

    return (
        <RegisterFlowTemplate
            step="2"
            title="Finish your profile setup"
            imageURL={image}
            quote="“It's a really great tool because you have everything in one place. I kid you not, I thought it was the godsend answer.”"
            author="Tim Sae Koo"
            role="CEO at Tint"
            authorImage={authorImage}
        >
            <Form<FormData> onSubmit={handleSubmit}>
                {({ submitError, invalid }) => (
                    <>
                        <FormItem
                            name="role"
                            label="What is your role?"
                            inputComponent={FormSelectSimple}
                            inputProps={{
                                placeholder: '',
                                options: ROLES.map(role => ({ value: role, label: role })),
                            }}
                            validators={[VALIDATORS.required({ errorMessage: 'Please select a role.' })]}
                        />
                        {/* we use isCompanySizeFilled for the origin field as well, as it means the admin still hasn't filled the settings */}
                        {!isCompanySizeFilled && (
                            <FormItem
                                name="companySize"
                                label="What is your company size?"
                                type="number"
                                validators={[
                                    VALIDATORS.required({
                                        errorMessage: 'Please enter your company size as a number.',
                                    }),
                                    VALIDATORS.number({ min: 1 }),
                                ]}
                                inputProps={{ inputMode: 'decimal' }}
                            />
                        )}

                        <div className={styles.formButtonContainer}>
                            <SaveButton state={'ENABLED'} labels={BUTTON_LABELS} disabled={invalid} />
                            {submitError ? <FormErrorMessage errorMessage={submitError} /> : null}
                        </div>
                    </>
                )}
            </Form>
        </RegisterFlowTemplate>
    );
}
